import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";

type FormItemWithMessageProps = {
  label: string;
  inputComponent: React.ReactElement;
  required?: boolean;
} & Omit<React.ComponentProps<typeof FormItem>, "children">;

export const FormItemWithMessage = ({
  label,
  inputComponent,
  required = false,
  ...props
}: FormItemWithMessageProps) => (
  <FormItem {...props}>
    <FormLabel>
      {label}
      {required ? " *" : ""}
    </FormLabel>
    <FormControl>{inputComponent}</FormControl>
    <div className="min-h-[20px]">
      <FormMessage />
    </div>
  </FormItem>
);
